export const deContent = {
  introduction: {
    content: [
      "Seit seinem Debüt im Jahr 1996 hat die Pokémon-Serie weltweit die Herzen erobert und ist zu einer der beliebtesten Unterhaltungsmarken geworden. Unser Zufalls-Pokémon-Generator wurde für Trainer aller Altersgruppen entwickelt, die neue Pokémon entdecken, ausgewogene Teams zusammenstellen oder einfach das Überraschungsmoment auf ihrer Pokémon-Reise genießen möchten.",
      "Ob Sie ein erfahrener Trainer auf der Suche nach Inspiration für Ihr nächstes Turnier-Team sind oder ein Gelegenheitsfan, der seinen Pokédex erweitern möchte - dieses Pokémon-Randomizer-Tool bietet eine unterhaltsame und interaktive Möglichkeit, die weite Welt der Pokémon zu erkunden."
    ]
  },
  howToUse: {
    content: [
      "Die Verwendung unseres Zufalls-Pokémon-Generators ist einfach und intuitiv. Folgen Sie diesen Schritten, um Ihr perfektes Pokémon-Team zu generieren:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Anzahl der Pokémon wählen: Entscheiden Sie, wie viele Pokémon generiert werden sollen (1-8)." },
          { type: "text", content: "Typ auswählen: Filtern Sie nach bestimmten Typen wie Feuer, Wasser, Elektro oder wählen Sie \"Alle\", um sämtliche Typen einzuschließen." },
          { type: "text", content: "Generation auswählen: Wählen Sie von Generation I bis VIII oder \"Alle\", um Pokémon aus allen Generationen einzuschließen." },
          { type: "text", content: "Seltenheitseinstellungen festlegen: Bestimmen Sie, wie selten Ihre generierten Pokémon sein sollen." },
          { type: "text", content: "Auf \"Generieren\" klicken: Sobald Sie Ihre Einstellungen vorgenommen haben, klicken Sie auf den Button, um Pokémon zu generieren, die Ihren Kriterien entsprechen." },
          { type: "text", content: "Ergebnisse erkunden: Überprüfen Sie die detaillierten Informationen für jedes Pokémon, einschließlich Statistiken, Fähigkeiten, Typen und mehr!" }
        ]
      },
      "Sie können diesen Vorgang beliebig oft wiederholen und Ihre Parameter anpassen, um verschiedene Pokémon-Kombinationen zu entdecken."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Völlig kostenlos: Unser Zufalls-Pokémon-Generator ist zu 100% kostenlos, ohne versteckte Gebühren oder Abonnements." },
          { type: "text", content: "Anpassbare Erfahrung: Filtern Sie nach Typ, Generation und Seltenheit, um Ihre Zufallsauswahl anzupassen." },
          { type: "text", content: "Lernwerkzeug: Lernen Sie verschiedene Pokémon-Arten, ihre Statistiken, Fähigkeiten und Typen kennen." },
          { type: "text", content: "Team-Building: Generieren Sie schnell ausgewogene Teams für Gelegenheitsspiele oder Wettkampfkämpfe." },
          { type: "text", content: "Herausforderungs-Generator: Erstellen Sie einzigartige Herausforderungen, indem Sie sich auf zufällig generierte Pokémon beschränken." },
          { type: "text", content: "Kein Konto erforderlich: Nutzen Sie das Tool sofort ohne Anmeldung oder persönliche Informationen." }
        ]
      }
    ]
  },
  history: {
    content: [
      "Die Pokémon-Franchise begann 1996, als Satoshi Tajiri die ersten Pokémon-Spiele für Nintendos Game Boy entwickelte. Inspiriert von Tajiris Kindheitshobby des Insektensammelns, konzentrierte sich das Konzept auf das Fangen, Trainieren und Kämpfen mit Kreaturen, die \"Pocket Monsters\" oder Pokémon genannt wurden.",
      "Wichtige Meilensteine in der Pokémon-Geschichte:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Veröffentlichung von Pokémon Rot und Grün in Japan" },
          { type: "text", content: "1998: Internationale Veröffentlichung von Pokémon Rot und Blau" },
          { type: "text", content: "1999: Weltweiter Start des Pokémon Trading Card Game" },
          { type: "text", content: "2000: Einführung von Gold und Silber, mit 100 neuen Pokémon" },
          { type: "text", content: "2016: Veröffentlichung von Pokémon GO, Einführung der Franchise auf mobilen Plattformen" },
          { type: "text", content: "2019: Debüt von Pokémon Schwert und Schild auf Nintendo Switch" }
        ]
      },
      "Heute, mit über 900 verschiedenen Pokémon-Arten über acht Generationen hinweg, hat sich die Franchise zu Videospielen, Sammelkarten, Animationsserien, Filmen, Merchandise und mobilen Anwendungen erweitert und ist damit eines der erfolgreichsten Medien-Franchises aller Zeiten."
    ]
  },
  popularPokemon: {
    content: [
      "Im Laufe der Pokémon-Geschichte sind mehrere Arten zu ikonischen Symbolen der Franchise geworden:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: Das Elektro-Maskottchen der Franchise, bekannt für seinen blitzförmigen Schwanz und die rosigen Wangen." },
          { type: "text", content: "Glurak: Ein Fan-Favorit vom Typ Feuer/Flug, bekannt für sein drachenähnliches Aussehen und mächtige Fähigkeiten." },
          { type: "text", content: "Mewtu: Ein legendäres Psycho-Pokémon, das durch genetische Manipulation von Mew erschaffen wurde, bekannt für seine immense Kraft." },
          { type: "text", content: "Evoli: Beliebt für seine einzigartige Fähigkeit, sich in verschiedene Typen zu entwickeln, einschließlich Aquana, Blitza und Flamara." },
          { type: "text", content: "Garados: Ein furchterregendes Wasser/Flug-Pokémon, das sich aus dem bescheidenen Karpador entwickelt." },
          { type: "text", content: "Lucario: Ein Kampf/Stahl-Typ, bekannt für seine Aura-Fähigkeiten und Beliebtheit im Wettkampf." },
          { type: "text", content: "Quajutsu: Ein Wasser/Unlicht-Ninja-Frosch-Pokémon, das durch die Animationsserie an Popularität gewann." }
        ]
      },
      "Unser Zufalls-Pokémon-Generator gibt Ihnen die Möglichkeit, diese ikonischen Kreaturen und viele weitere, weniger bekannte, aber ebenso faszinierende Arten zu entdecken."
    ]
  },
  popularGames: {
    content: [
      "Die Pokémon-Spieleserie hat zahlreiche beliebte Titel auf verschiedenen Plattformen hervorgebracht:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Rot, Blau und Gelb: Die Originalspiele, die das Phänomen auf dem Game Boy starteten." },
          { type: "text", content: "Pokémon Gold, Silber und Kristall: Führten die Johto-Region und Tag/Nacht-Zyklen ein." },
          { type: "text", content: "Pokémon Rubin, Saphir und Smaragd: Erweiterten die Welt mit der Hoenn-Region und Doppelkämpfen." },
          { type: "text", content: "Pokémon Diamant, Perl und Platin: Brachten die Serie mit Online-Funktionalität auf den Nintendo DS." },
          { type: "text", content: "Pokémon Schwarz und Weiß: Präsentierten einen komplett neuen Satz Pokémon und einen stärker story-getriebenen Ansatz." },
          { type: "text", content: "Pokémon X und Y: Führten 3D-Modelle und Mega-Entwicklung ein." },
          { type: "text", content: "Pokémon Sonne und Mond: Gestalteten das Arena-System mit Inselprüfungen neu." },
          { type: "text", content: "Pokémon GO: Das Augmented-Reality-Handyspiel, das zu einem globalen Phänomen wurde." },
          { type: "text", content: "Pokémon Schwert und Schild: Brachten die Serie mit dem Konzept der Naturzone auf die Nintendo Switch." },
          { type: "text", content: "Pokémon-Legenden: Arceus: Ein neuer Open-World-Ansatz für die Serie." }
        ]
      },
      "Jedes Spiel führt neue Mechaniken und Pokémon ein und erweitert das Universum, das unser Zufalls-Pokémon-Generator Ihnen hilft zu erkunden."
    ]
  },
  tradingContests: {
    content: [
      "Der Pokémon-Tausch ist seit Beginn ein fundamentaler Aspekt der Franchise. Die Originalspiele wurden speziell paarweise veröffentlicht, um Spieler zum Tauschen mit Freunden zu ermutigen, um ihren Pokédex zu vervollständigen. Dieses soziale Element half, Pokémons Popularität zu verbreiten und ist auch heute noch wichtig.",
      "Wichtige Aspekte des Tauschens:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Versions-exklusive Pokémon, die nur durch Tausch erhältlich sind" },
          { type: "text", content: "Tausch-Entwicklungen für bestimmte Arten wie Maschock und Kadabra" },
          { type: "text", content: "Globale Tauschsysteme in modernen Spielen ermöglichen weltweite Tauschaktionen" },
          { type: "text", content: "Tauschen von seltenen oder Shiny-Pokémon als Statussymbole" }
        ]
      },
      "Pokémon-Wettbewerbe, die in Generation III eingeführt wurden, bieten eine Alternative zu Kämpfen, bei denen Pokémon basierend auf Aussehen, Performance und Anmut statt Stärke konkurrieren. Diese Wettbewerbe umfassen:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Verschiedene Wettbewerbskategorien (Coolness, Schönheit, Anmut, Klugheit, Stärke)" },
          { type: "text", content: "Spezielle Attacken, die speziell für Wettbewerbe entwickelt wurden" },
          { type: "text", content: "Pokémon-Konditionsverwaltung durch Beeren und Pokériegel" },
          { type: "text", content: "Mehrstufige Wettbewerbe mit vorläufigen visuellen Bewertungen und Vorführungsrunden" }
        ]
      },
      "Unser Zufalls-Pokémon-Generator kann Ihnen helfen, Pokémon zu entdecken, die in Wettbewerben hervorragend sein könnten oder wertvolle Tauschpartner werden könnten, und fügt Ihrer Pokémon-Erfahrung eine weitere Dimension hinzu."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Ist dieser Zufalls-Pokémon-Generator kostenlos?",
            answer: "Ja, unser Tool ist völlig kostenlos, ohne versteckte Kosten oder Abonnement-Anforderungen."
          },
          {
            type: "faq",
            question: "Wie genau sind die Pokémon-Daten?",
            answer: "Alle Daten stammen aus der offiziellen PokéAPI, was Genauigkeit und aktuelle Informationen gewährleistet."
          },
          {
            type: "faq",
            question: "Kann ich Pokémon aus einer bestimmten Generation generieren?",
            answer: "Ja, Sie können nach Generation von I bis VIII filtern oder \"Alle\" wählen, um alle Generationen einzuschließen."
          },
          {
            type: "faq",
            question: "Wie funktioniert der Seltenheitsfilter?",
            answer: "Unser Algorithmus weist Seltenheitswerte basierend auf Faktoren wie legendärem/mythischem Status, Basis-Erfahrung und anderen Attributen zu, um eine Seltenheitsskala von 1-10 zu erstellen."
          },
          {
            type: "faq",
            question: "Kann ich die generierten Pokémon speichern oder exportieren?",
            answer: "Derzeit können Sie Screenshots Ihrer Ergebnisse machen. Wir erwägen, in zukünftigen Updates Speicher-/Export-Funktionen hinzuzufügen."
          },
          {
            type: "faq",
            question: "Ist der Zufalls-Pokémon-Generator mobilfreundlich?",
            answer: "Ja, unser Generator ist vollständig responsive und funktioniert auf Smartphones, Tablets und Desktop-Computern."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Unser zufälliger Pokémon-Generator bietet endlose Möglichkeiten für Gelegenheitsspieler und engagierte Trainer gleichermaßen. Ob du neue Favoriten entdecken, thematische Teams erstellen oder dich mit unerwarteten Kombinationen herausfordern möchtest, unser Tool bietet eine unterhaltsame und lehrreiche Möglichkeit, die riesige Welt der Pokémon zu erkunden.",
      "Wir arbeiten ständig daran, den Generator mit neuen Funktionen und Optionen zu verbessern. Probiere es noch heute aus, indem du deine Präferenzen festlegst und auf \"Generieren\" klickst, um zu sehen, welche Pokémon auf dich warten!",
      "Teile deine Ergebnisse mit Freunden und anderen Trainern und lass uns wissen, wie du den zufälligen Pokémon-Generator auf deiner Pokémon-Reise nutzt. Viel Spaß beim Entdecken!"
    ]
  },
  // Inhaltsabschnitte für "Welches Pokémon bin ich?"
  whichPokemonIntro: {
    content: [
      "Hast du dich jemals gefragt, welchem Pokémon du am meisten ähnelst? Unser \"Welches Pokémon bin ich\"-Tool bietet eine unterhaltsame und einzigartige Möglichkeit, dein Pokémon-Gegenstück basierend auf deinen körperlichen Merkmalen zu entdecken.",
      "Diese innovative Funktion analysiert deine Größe und dein Gewicht, um das Pokémon zu identifizieren, das deinen Proportionen am nächsten kommt. Ob du so groß wie ein Glurak oder so kompakt wie ein Pikachu bist, unser Algorithmus findet mit überraschender Genauigkeit dein perfektes Pokémon-Match."
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "Die Verwendung unseres \"Welches Pokémon bin ich\"-Tools ist einfach und dauert nur wenige Sekunden. Folge diesen einfachen Schritten, um dein Pokémon-Match zu entdecken:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Gib deinen Namen (oder Spitznamen) in das bereitgestellte Formular ein." },
          { type: "text", content: "Gib deine Größe in Zentimetern (cm) ein." },
          { type: "text", content: "Gib dein Gewicht in Kilogramm (kg) ein." },
          { type: "text", content: "Klicke auf die Schaltfläche \"Mein Pokémon finden\", um deine Ergebnisse zu sehen." },
          { type: "text", content: "Sieh dir dein übereinstimmendes Pokémon an, einschließlich Name, Typ, Größe, Gewicht und Ähnlichkeitswert." },
          { type: "text", content: "Teile deine Ergebnisse in sozialen Medien oder lade sie als Bild herunter, um sie deinen Freunden zu zeigen!" }
        ]
      },
      "Der Ähnlichkeitswert gibt an, wie nahe deine Proportionen denen des Pokémon entsprechen. Je höher der Prozentsatz, desto näher ist das Match!"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "Die Entdeckung deines Pokémon-Gegenstücks bietet mehr als nur Unterhaltungswert:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Spaßvolle Lernmethode: Entdecke und lerne neue Pokémon kennen, die deinen körperlichen Merkmalen entsprechen." },
          { type: "text", content: "Einzigartige Perspektive: Sieh dich selbst durch die Linse der Pokémon-Welt." },
          { type: "text", content: "Gesprächsstarter: Teile deine Ergebnisse mit Freunden und vergleiche, welches Pokémon zu jedem von euch passt." },
          { type: "text", content: "Cosplay-Inspiration: Finde ein Pokémon, das natürlich zu deinem Körpertyp passt, für Cosplay-Ideen." },
          { type: "text", content: "Team-Building: Erstelle ein thematisches Team in Pokémon-Spielen, das auf körperlichen Ähnlichkeiten zu dir und deinen Freunden basiert." }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Wie genau ist der Matching-Algorithmus?",
            answer: "Unser Algorithmus verwendet offizielle Pokémon-Größen- und Gewichtsdaten von der PokéAPI und berechnet die Ähnlichkeit basierend auf der proportionalen euklidischen Distanz. Obwohl er eher für Spaß als für wissenschaftliche Genauigkeit konzipiert ist, finden viele Benutzer die Übereinstimmungen überraschend passend!"
          },
          {
            type: "faq",
            question: "Warum berücksichtigt das Tool keine anderen körperlichen Merkmale?",
            answer: "Derzeit konzentrieren wir uns der Einfachheit halber auf Größe und Gewicht, und weil dies die am konsistentesten dokumentierten physischen Attribute über alle Pokémon-Arten hinweg sind. Wir werden in zukünftigen Updates möglicherweise weitere Attribute hinzufügen."
          },
          {
            type: "faq",
            question: "Kann ich mit jedem Pokémon übereinstimmen?",
            answer: "Derzeit gleicht das Tool mit den ursprünglichen 151 Pokémon (Generation I) ab, um die Leistung zu optimieren. Wir planen, dies in zukünftigen Updates zu erweitern, um alle Generationen einzuschließen."
          },
          {
            type: "faq",
            question: "Werden meine persönlichen Daten gespeichert oder geteilt?",
            answer: "Nein, wir speichern weder deine Größe, dein Gewicht noch andere persönliche Informationen, die du eingibst. Alle Berechnungen werden in deinem Browser durchgeführt, und nichts wird an unsere Server gesendet."
          },
          {
            type: "faq",
            question: "Warum habe ich ein anderes Pokémon als mein Freund mit ähnlichen Maßen?",
            answer: "Kleine Unterschiede im Verhältnis von Größe zu Gewicht können zu unterschiedlichen Übereinstimmungen führen. Der Algorithmus betrachtet Proportionen anstelle von absoluten Werten."
          },
          {
            type: "faq",
            question: "Kann ich meine Ergebnisse in sozialen Medien teilen?",
            answer: "Ja! Du kannst dein Ergebnis als Bild herunterladen oder mit den bereitgestellten Schaltflächen direkt auf Plattformen wie Facebook und Twitter teilen."
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "Unser \"Welches Pokémon bin ich\"-Tool bietet einen spielerischen Einblick, wie du in der wunderbaren Welt der Pokémon existieren könntest. Obwohl es hauptsächlich zur Unterhaltung gedacht ist, entdecken viele Benutzer überraschende Verbindungen zur Persönlichkeit oder zu den Fähigkeiten ihres zugeordneten Pokémon, die über bloße körperliche Ähnlichkeiten hinausgehen.",
      "Versuche, deine Eingaben leicht zu ändern, um zu sehen, wie unterschiedliche Größen und Gewichte deine Übereinstimmungen beeinflussen, oder fordere Freunde und Familie heraus, ihre Pokémon-Gegenstücke zu finden. Du könntest von den resultierenden Pokémon-Paarungen überrascht sein!",
      "Ob du mit einem majestätischen Legendären Pokémon, einem kraftvollen Starter oder einem unterschätzten Taschenmonster übereinstimmst, umarme dein Pokémon-Gegenstück und die einzigartigen Eigenschaften, die ihr teilt. Schließlich hat in der Welt der Pokémon jede Art ihre eigenen besonderen Stärken und ihre Bedeutung."
    ]
  }
}; 